<h1>Activity Log Grid component</h1>
<p>Select a pre-defined activity log type, then provide required context values.</p>

<ui-form
  [config]="selectorAndGridInputConfigs"
  [(formValues)]="selectorAndGridFormValues"
  [useAutoSave]="false"
  (formValuesChange)="onSelectorAndGridFormValuesChange($event)"
/>

@if (showAddOnlyParamsForm) {
  <p>Additional parameters required for Add Activity:</p>
  <ui-form
    [config]="addOnlyContextInputConfigs"
    [(formValues)]="addOnlyContextFormValues"
    [useAutoSave]="false"
    (formValuesChange)="onAddOnlyContextFormValuesChange($event)"
  />
}

<app-activity-log-grid
  [activityLogType]="selectedActivityLogType"
  [activityLogContext]="activityLogContext"
  [hideAddActivity]="hideAddActivity"
/>
